(function () {
  'use strict';

  angular.module('wsLrs.controllers').factory("OrganizationSettings", ['Resource', '$rootScope', "$q", "User", "wsConfig", "Api", "Logger", function (Resource, $rootScope, $q, User, wsConfig, Api, Logger) {
    var settingsUrl = "/settings/protected";
    var publicUrl = "/settings/public";
    var resource = new Resource(settingsUrl, false);
    var settingsCache = {};
    var settingsPromises = {};

    // Any tenant bound API urls must be reset when the org changes
    $rootScope.$on('organization-selected', function () {
      settingsCache = {};
      settingsPromises = {};
      resource.__value = null;
    });
    var self = _.extend(resource, {
      __value: null,
      save: undefined,
      remove: undefined,
      find: undefined,
      list: undefined,
      getForOrganization: function getForOrganization(id) {
        if (id === undefined) {
          return $q.reject('No ID was passed to getForOrganization()');
        }
        var user = User.get();
        //if we don't find a user or if the user is unauthenticated get the org settings with no auth
        var url = "/organizations/" + id + (!user || user.unauthenticated ? publicUrl : settingsUrl);
        if (!settingsPromises[url]) {
          settingsPromises[url] = new Resource(url, true).get();
        }
        return settingsPromises[url];
      },
      get: _.wrap(resource.get, function (f) {
        if (resource.__value === null) {
          resource.__value = _.bind(f, resource)();
        }
        return resource.__value;
      }),
      getCachedPricingTier: function getCachedPricingTier() {
        var url = Api.url(settingsUrl);
        return settingsCache[url] ? settingsCache[url].pricingTier : "";
      },
      getSettingsSync: function getSettingsSync() {
        var user = User.get();
        if (!user || !user.organization || user.unauthenticated) {
          return {};
        }
        var url = Api.url(settingsUrl);
        if (!settingsCache[url]) {
          settingsCache[url] = JSON.parse($.ajax({
            type: "GET",
            dataType: "json",
            url: url,
            async: false,
            error: function fetchConfigurationError(response) {
              Logger.warn("Organization settings fetch failed with response status " + response.status);
            }
          }).responseText);
        }
        return settingsCache[url];
      },
      hasFeature: function hasFeature(featureName) {
        var settings = self.getSettingsSync();
        if (!settings || !settings.featurePermissions) {
          return false;
        }
        if (!settings.featurePermissions.hasOwnProperty(featureName)) {
          throw "ERROR: Unknown feature permission '" + featureName + "'requested.";
          // Write to server-side log and return false?
        }
        return settings.featurePermissions[featureName];
      }
    });
    return self;
  }]);
})();
